import * as types from './types';

export const signInAction = ({ email, password }) => ({
  type: types.SIGN_IN_TYPE,
  payload: { email, password },
});

export const setIsAuthenticatedAction = isAuthenticated => ({
  type: types.SET_IS_AUTHENTICATED_TYPE,
  payload: { isAuthenticated },
});

export const setAuthenticationAction = ({ isSignUp = false, withSocialProvider = false } = {}) => ({
  type: types.SET_AUTHENTICATION,
  payload: { isSignUp, withSocialProvider },
});

export const setUserInfoAction = ({ user }) => ({
  type: types.SET_USER_INFO_TYPE,
  payload: { user },
});

export const signUpAction = ({ email, password }) => ({
  type: types.SIGN_UP,
  payload: { email, password },
});

export const verifyCodeSignUpAction = ({ code, email }) => ({
  type: types.VERIFICATION_CODE_SIGNUP,
  payload: { code, email },
});

export const resendVerifyCodeSignUpAction = ({ email }) => ({
  type: types.RESEND_VERIFICATION_CODE_SIGNUP,
  payload: { email },
});

export const verifyCodeChangeAction = ({ code }) => ({
  type: types.CODE_CONFIRM,
  payload: { code },
});

export const forgotPasswordAction = ({ email }) => ({
  type: types.FORGOT_PASSWORD,
  payload: { email },
});

export const signOutAction = () => ({
  type: types.SIGN_OUT,
  payload: {},
});

export const resetPasswordAction = ({ email, password, validationCode }) => ({
  type: types.RESET_PASSWORD,
  payload: { email, password, validationCode },
});

export const resendResetPassCodeAction = ({ email }) => ({
  type: types.RESEND_RESET_PASSWORD_CODE,
  payload: { email },
});

export const resetStoreAction = () => ({
  type: types.RESET_STORE_TYPE,
});

export const updatePasswordAction = values => ({
  type: types.UPDATE_PASSWORD,
  payload: values,
});

export const signInSocialAction = provider => ({
  type: types.SIGN_IN_SOCIAL,
  payload: { provider },
});

export const setUserCouponAction = coupon => ({
  type: types.SET_USER_COUPON,
  payload: { coupon },
});

export const setUserCodeAction = (code, source) => ({
  type: types.SET_USER_CODE,
  payload: { code, source },
});

export const signUpSetEmailAction = ({ email }) => ({
  type: types.SIGN_UP_SET_EMAIL,
  payload: { email },
});

export const confirmSignUpAction = ({ token, ref }) => ({
  type: types.CONFIRM_SIGN_UP,
  payload: { token, ref },
});

export const resendConfirmationCodeAction = email => ({
  type: types.RESEND_CONFIRMATION_CODE,
  payload: { email },
});

export const resendLinkAction = email => ({
  type: types.RESEND_LINK,
  payload: { email },
});
